<template>
  <div class="integral" v-if="wangba != null">
    <template>
      <div class="title">
        <div class="num">{{ user == null ? 0 : user }}</div>
        <div class="sysum">剩余积分</div>
        <div class="card">
          <div
            class="card_name"
            :style="{ width: wbFlag == true ? 'auto' : '100%' }"
          >
            {{ wangba.site_name }}
          </div>
          <div
            v-if="wbFlag == true"
            class="card_btn"
            @click="
              $router.push({
                path: '/choosebar',
                query: {
                  url: '/integral',
                },
              })
            "
          >
            切换网吧
          </div>
        </div>
      </div>
      <div class="list_item">
        <div
          class="item_title"
          :style="{ marginBottom: list.length > 0 ? '10px' : '0' }"
        >
          积分明细
        </div>
        <div class="item" v-for="(item, i) in list" :key="i">
          <span class="date">{{ item.date }}</span>
		  <span class="num"  v-if="item.integral < 0">{{ item.integral }}</span>
		  <span class="num" v-else>+{{ item.integral }}</span>
        </div>
      </div>
    </template>
  </div>
  <van-skeleton title avatar :row="20" v-else />
</template>

<script>
import { getUserIntegral } from "@/api/draw.js";
import { chooseBarList } from "@/api/index";
export default {
  data() {
    return {
      list: [],
      user: null,
      wangba: null,
      wbFlag: false,
    };
  },
  created() {
    const body = document.body;
    body.style.background = "#f6f6f6";
    const cookiesId = this.$cookies.get("internetBarId");
    const query = this.$route.query;
    this.getList(query.id == undefined ? cookiesId : query.id);
    this.getChooseBarList(query.id == undefined ? cookiesId : query.id);
    this.requestChooseBarList();
  },
  methods: {
    requestChooseBarList() {
      chooseBarList().then((res) => {
        console.log(res);
        if (res.data.length == 1) {
          this.wbFlag = false;
        } else {
          this.wbFlag = true;
        }
      });
    },
    async getList(internetBarId) {
      const userId = JSON.parse(window.sessionStorage.getItem("loginInfo")).id;
      const data = await getUserIntegral({ internetBarId, userId });
      if (data.code == 200) {
        this.list = data.data.userIntegralList;
        this.user = data.data.userIntegral;
      }
    },
    async getChooseBarList(internetBarId) {
      const userId = JSON.parse(window.sessionStorage.getItem("loginInfo")).id;
      const data = await chooseBarList({ userId });
      data.data.forEach((item) => {
        if (item.internetBarId == internetBarId) {
          this.wangba = item;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.integral {
  // width: 100%;
  // height: 100%;
  padding: 15px;
  background: url("../../../images/integral.png") no-repeat;
  background-size: 100% 225px;
  background-color: #f6f6f6;
  .title {
    width: 100%;
    height: 170px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .num {
      width: 100%;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 700;
      color: #ffffff;
    }
    .sysum {
      width: 100%;
      margin-top: 15px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba($color: #fff, $alpha: 0.7);
    }
    .card {
      font-size: 14px;
      padding: 0 15px;
      font-family: PingFang SC;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      bottom: -55px;
      width: 100%;
      height: 55px;
      border-radius: 8px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      .card_name {
        color: #333;
      }
      .card_btn {
        color: #0193ff;
      }
    }
  }
  .list_item {
    padding: 15px;
    margin-top: 65px;
    width: 100%;
    background-color: #fff;
    border-radius: 12px;
    text-align: left;
    .item_title {
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
    }
    .item {
      padding: 20px 0;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:last-child {
        border: none;
      }
      .date {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .num {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ff6666;
      }
    }
  }
}
</style>
